module.exports = __webpack_public_path__ + "img/PL08369.2e726ac4.png";